@let tableName = this.tableName();
@let inside = this.inside();

<ng-container coreActivitySection="Header">
  <app-button-back
    class="back"
    [inside]="inside"
    (click)="backButtonClick.emit($event)"
    [routerLink]="backButtonRouterLink()"
    [coreUserActivityClickTracking]="backButtonUserActivity()"
  />

  <img class="logo" src="images/logo.svg" width="125" height="66" alt="logo" />

  <div class="table">
    {{ tableName }}
  </div>
</ng-container>
